import { render } from "./Indicator.vue?vue&type=template&id=452cf2aa&scoped=true&ts=true"
import script from "./Indicator.vue?vue&type=script&lang=ts"
export * from "./Indicator.vue?vue&type=script&lang=ts"

import "./Indicator.vue?vue&type=style&index=0&id=452cf2aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452cf2aa"]])

export default __exports__